import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as style from './Image.css';
import { NoImage } from '../NoImage';
import { Spinner } from '../Spinner';

export enum ELoadingStatus {
  Loading = 0,
  Loaded = 1,
  Error = 2,
}

export interface IImageError {
  text?: string;
  img?: string;
}

export interface IImageState {
  status: ELoadingStatus;
}

export interface IImageProps {
  alt?: string;
  src: string;
  error?: IImageError;
  fit?: 'cover' | 'contain';
  spinnerSize?: number;
}

export class Image extends React.Component<IImageProps, IImageState> {
  public state = {
    status: ELoadingStatus.Loading,
  };

  public render() {
    const { alt = '', src, error, fit = 'contain', spinnerSize } = this.props;
    const { status } = this.state;

    const isLoading = status === ELoadingStatus.Loading;
    const isError = status === ELoadingStatus.Error;

    return (
      <div {...mergeStyles(style['image'], style[`image--${fit}`])}>
        {!isError && (
          <div className={style['image-container']}>
            <img alt={alt} src={src} onLoad={this.onLoad} onError={this.onError} />
          </div>
        )}
        {isLoading && <Spinner size={spinnerSize} />}
        {!isLoading && isError && error && <NoImage {...error} />}
      </div>
    );
  }

  public onLoad = () => {
    this.setState({ status: ELoadingStatus.Loaded });
  };

  public onError = () => {
    this.setState({ status: ELoadingStatus.Error });
  };
}
